import { Directive, ElementRef, Input } from '@angular/core';
import * as anime from 'animejs/lib/anime';

@Directive({
  selector: '[shake]'
})
export class ShakeDirective {
  @Input() animeStrength: number = 16;
  private animation: any;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.animation = anime({
      targets: [this.el.nativeElement],
      easing: 'easeInOutSine',
      duration: 550,
      loop: 0,
      translateX: [
        {
          value: this.animeStrength * -1,
        },
        {
          value: this.animeStrength,
        },
        {
          value: this.animeStrength / -2,
        },
        {
          value: this.animeStrength / 2,
        },
        {
          value: 0
        }
      ],
    });
  }

  public play() {
    this.animation.play();
  }
}
